<template>
  <h1 class="title" v-if="title !== null">{{ title }}</h1>
</template>

<script>
/**
 * Copyright (c) 2019. Filip Conka <filip@conka.pro>
 */
export default {
  name: 'ContentTitle',
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>

</style>
